import { useLayoutEffect, useState } from 'react';

import isEqual from 'react-fast-compare';

const getHiddenColumnsForWidth = (containerWidth, hiddenColumnsForWidthMap, initialHiddenColumns = []) => {
  const newHiddenColumns = initialHiddenColumns;

  Object.entries(hiddenColumnsForWidthMap).forEach(([k, v]) => {
    if (containerWidth <= Number(k)) {
      newHiddenColumns.push(...v);
    }
  });

  return newHiddenColumns;
};

export const useHiddenColumnsForTableWidth = (
  containerWidth,
  hiddenColumnsForWidthMap,
  initialHiddenColumns = [],
  getOtherHiddenColumns = undefined,
) => {
  const [hiddenColumns, setHiddenColumns] = useState(() =>
    getHiddenColumnsForWidth(containerWidth, hiddenColumnsForWidthMap, initialHiddenColumns),
  );

  useLayoutEffect(() => {
    if (!containerWidth) {
      return;
    }

    setHiddenColumns((prevState) => {
      const oldHiddenColumns = [...prevState];

      const otherHiddenColumns = getOtherHiddenColumns?.() ?? [];

      const newHiddenColumns = [...otherHiddenColumns, ...getHiddenColumnsForWidth(containerWidth, hiddenColumnsForWidthMap)];

      // compare new array to old
      const hasChanged = !isEqual(oldHiddenColumns, newHiddenColumns);

      return hasChanged ? newHiddenColumns : prevState;
    });
  }, [containerWidth, getOtherHiddenColumns, hiddenColumnsForWidthMap]);

  return hiddenColumns;
};
